import { useState, useMemo, useEffect, useRef } from 'react';
import { Usuario } from '../../types';
import axiosCAF from "../../../../components/Config/AxiosIni";
import Swal from 'sweetalert2';
import { useUtil } from '../../../../components/Util/useUtil';



export function useUsuarioTableLogic() {
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [selectedUser, setSelectedUser] = useState<Usuario | null>(null);
    const [open, setOpen] = useState(false);
    const [usuarios, setUsuarios] = useState<Usuario[]>([]);
    const [formData, setFormData] = useState<Usuario | null>(null);
    const [imagePreview, setImagePreview] = useState(formData?.avatar || ''); // Para la vista previa de la imagen    
    const [loading, setLoading] = useState(false); // Para mostrar el cargando si se está subiendo la imagen        
    const [changePass, setChangePass] = useState<boolean>(false);
    const inputRef = useRef<HTMLInputElement>(null);

    const {      
        FormatDateAMD,  
        FormatDate,
      }=useUtil(); 
    

    // Manejar cambio de imagen
    const handleImageChange = (e :  React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) {               
        setLoading(true);
        setSelectedUser(prevUser => 
            prevUser ? { ...prevUser, cmp_avatar: file.name, imagen: file } : null
        );
        const reader = new FileReader();
        reader.onloadend = () => {
        setImagePreview(reader.result as string);        
        setLoading(false);
    };        
        reader.readAsDataURL(file);
    }
    };

     //* Función para enfocar el input
    const enfocarInput = () => {
        if (inputRef.current) {
        inputRef.current.focus();
        }
    };

    const handleChangePage = (_: unknown, newPage: number) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const handleRowClick = (user: Usuario) => {
        setSelectedUser(user);
        setOpen(true);
        
    };

    const handleClose = () => {
        setOpen(false);
        setSelectedUser(null);
        setImagePreview('');
    };

    const paginatedUsers = useMemo(
        () => usuarios.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage),
        [usuarios, page, rowsPerPage]
    );
    //*Procedimiento para cambiar la clave del usuario
    const handleChangePass =()=>{         
        setSelectedUser(prevUser => 
        prevUser ? { ...prevUser, changePass: !changePass } : null);        
        setChangePass(!changePass);
    }
    //* Procedimientoa para cargar todos los socios para el admin del sistema    
    const loadSocios= async ()=>{
        try {
            const response = await axiosCAF.get('/socio/allsocios');            
            setUsuarios(response.data);            
        } catch (error: any) {
            console.log('ariel-error',error);
            Swal.fire(
                "Error Leer Atte.",
                error.response?.data?.message || "Error inesperado",
                "error"
            );
        }        
    }    
    //* Procedimiento Para grabar los datos modificaciones
    const handleSave = async() => {   
       
        console.log('arel-save',formData);
        if (formData) {            
            try {
                const response = await axiosCAF.post('/socio/updatesocio', formData);            
                setChangePass(false);
                if(response.data.message=='Ok'){                    
                    const Toast = Swal.mixin({
                        toast: true,
                        position: "top-end",
                        showConfirmButton: false,
                        timer: 3000,
                        timerProgressBar: true,
                        didOpen: (toast) => {
                            toast.onmouseenter = Swal.stopTimer;
                            toast.onmouseleave = Swal.resumeTimer;
                            }
                        });
                        Toast.fire({
                            icon: "success",
                            title: "Actualizaciones Grabadas Correctamente!!!"
                    });    
                    loadSocios();
                }else{
                    const Toast = Swal.mixin({
                        toast: true,
                        position: "top-end",
                        showConfirmButton: false,
                        timer: 3000,
                        timerProgressBar: true,
                        didOpen: (toast) => {
                            toast.onmouseenter = Swal.stopTimer;
                            toast.onmouseleave = Swal.resumeTimer;
                            }
                        });
                        Toast.fire({
                            icon: "error",
                            title: "Error a grabar las actualizaciones, intente mas tarde!!!"
                    });    
                }
            } catch (error:any) {
                console.log('ariel-error',error);
                Swal.fire(
                    "Error Leer Atte.",
                    error.response?.data?.Message?.message || "Error inesperado",
                    "error"
                );
            } 
        }    
        handleClose();
    };

    const handleFieldChange = (field: keyof Usuario, value: any) => {
    setFormData(prev => prev ? { ...prev, [field]: value } : null);
    };

    useEffect(() => {
        loadSocios();
    }, []);

    useEffect(() => {
        if (selectedUser) {
        setFormData(selectedUser);
        setImagePreview(selectedUser.avatar);
    }
    }, [selectedUser]);

    useEffect(() => {
        enfocarInput();
    }, [changePass])    

    return {
        page,
        rowsPerPage,
        selectedUser,
        open,
        paginatedUsers,
        usuarios,
        formData,
        imagePreview,     
        loading,   
        changePass, 
        inputRef,        
        setChangePass,
        setImagePreview,
        setFormData,
        handleSave,
        handleFieldChange,
        handleChangePage,
        handleChangeRowsPerPage,
        handleRowClick,
        handleClose,
        handleImageChange,
        handleChangePass,
    };
}